<div class="bg-quovo-gray">
  <app-search-panel (onSearch)="onSearch($event)"></app-search-panel>
  <div class="mb-7 lg:mx-8">
    <app-swiper-component [filteredSwipers]="filteredSwipers"></app-swiper-component>
  </div>
</div>
